import { defineStore } from 'pinia'

import { initCaptcha, login, register } from '@/services/auth/authApi'
import type { LoginCredentials, RegisterCredentials } from '@/types/auth'
import { logger } from '@myorg/type-lib'

export interface UserInfo {
  userId: string
  merchantId: string
  name: string
  roles: string[]
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isLoggedIn: false,
    user: null as UserInfo | null,
    error: '',
    message: '',
  }),

  actions: {
    setLoginStatus(status: boolean) {
      this.isLoggedIn = status
    },

    setUser(user: UserInfo | null) {
      this.user = user
    },

    setError(msg: string) {
      this.error = msg
    },

    setMessage(msg: string) {
      this.message = msg
    },

    clearAuthData() {
      this.isLoggedIn = false
      this.user = null
    },

    clearMessages() {
      this.error = ''
      this.message = ''
    },

    async handleLogin(data: LoginCredentials & { rememberMe: boolean }) {
      this.clearMessages()
      logger.log('handleLogin data', data)

      try {
        const res = await login(data)
        this.message = '登入成功'
        return res
      } catch (err: any) {
        this.error = err.response?.data?.message || '登入失敗'
        throw err
      }
    },

    async handleRegister(data: RegisterCredentials) {
      this.clearMessages()

      try {
        const res = await register(data)
        this.message = '註冊成功'
        return res
      } catch (err: any) {
        this.error = err.response?.data?.message || '註冊失敗'
        throw err
      }
    },

    async initCaptcha() {
      try {
        return await initCaptcha()
      } catch (err) {
        this.error = '取得驗證碼失敗'
        throw err
      }
    },
  },
})
